import React, { useState } from "react";
import { LuPause, LuPlay } from "react-icons/lu";
import useTitanApp from "../../../hooks/useTitanApp";
import { ConsultationButtonStatus } from "../../../enum/ConsultationButtonStatus";
import { updateConsultationButtonStatus } from "../../../dispatchers/patientDispatchers";
import { setConsultationLoadError } from "../../../dispatchers/appDispatchers";

export default function PatientConsultationPlayPauseButton({
  pauseTranscription,
  resumeTranscription,
  initializeTranscriptionAfterRefresh,
  mediaRecorderRef,
}) {
  const { appState, patientState } = useTitanApp();
  const { darkMode } = appState || {};
  const {
    consultationStarted,
    isSummaryStreaming,
    consultationPaused,
    selectedPatientConsultation,
    isDemDxActive,
    consultationId,
    isLocallyCompleted,
    transcript,
    consultationMediaButtonMode
  } = patientState || {};

const handleButtonClick = async () => {
  try {
    const data = {
      consultationId: consultationId,
      buttonStatus: ConsultationButtonStatus.Pause,
    };
    await updateConsultationButtonStatus(data);

    if (
      isSummaryStreaming ||
      isDemDxActive
      // ||
      // selectedPatientConsultation?.consultationStatus === 2
    )
      return;

    if (consultationStarted && !consultationPaused) {
      pauseTranscription();
    } else if (consultationPaused) {
      if (!mediaRecorderRef.current) {
        initializeTranscriptionAfterRefresh();
      } else {
        resumeTranscription();
      }
    }
  } catch (error) {
    console.error("Error handling button click:", error);
    setConsultationLoadError(true); 
  }
};
 if (
    isLocallyCompleted ||
    !transcript?.trim() ||
    isDemDxActive ||
    selectedPatientConsultation?.consultationButtonStatus ===
    ConsultationButtonStatus.Completed ||
    consultationMediaButtonMode === "manual"
  ) {
    return null;
  }
  return (
    <div
      className={`pc-play-pause-btn ${
        selectedPatientConsultation?.consultationButtonStatus ===
        ConsultationButtonStatus.Pause
      }`}
      onClick={handleButtonClick}
    >
      {consultationPaused ? <LuPlay /> : <LuPause />}
      <p>{consultationPaused ? "Resume" : "Pause"}</p>
    </div>
  );
}
